"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledClearButton = exports.StyledCloseIcon = exports.StyledChip = exports.StyledChipsWrapper = exports.StyledChips = void 0;
const ui_components_1 = require("@groupby/ui-components");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const styled_components_1 = __importDefault(require("styled-components"));
const TEXT_DECORATION = {
    included: 'none',
    excluded: 'line-through',
};
const COLORS = {
    included: ui_components_1.baseColors.primaryBlueDark500,
    excluded: ui_components_1.baseColors.white,
};
const BACKGROUNDS = {
    included: ui_components_1.baseColors.primaryGreen000,
    excluded: '#B5366D',
};
exports.StyledChips = styled_components_1.default.div `
  display: flex;
  align-items: center;

  margin-left: 0.75rem;
`;
exports.StyledChipsWrapper = styled_components_1.default.div `
  width: 100%;
  max-width: 35rem;
  max-height: 6rem;

  overflow-y: auto;
`;
exports.StyledChip = (0, styled_components_1.default)(ui_components_1.Chip) `
  &&& {
    margin-right: 0.2rem;
    margin-bottom: 0.4rem;
    padding: 0;

    min-height: 0;

    text-decoration: ${(props) => TEXT_DECORATION[props.$itemType]};
    color: ${(props) => COLORS[props.$itemType]};
    background-color: ${(props) => BACKGROUNDS[props.$itemType]};

    .MuiChip-label {
      padding-left: ${({ theme: { spacing } }) => spacing(1)};
      padding-right: 0;
    }
  }
`;
exports.StyledCloseIcon = (0, styled_components_1.default)(Close_1.default) `
  &&&.MuiChip-deleteIcon {
    margin: 0;

    color: ${(props) => COLORS[props.$itemType]};
    transform: scale(0.6);
  }
`;
exports.StyledClearButton = (0, styled_components_1.default)(ui_components_1.Button) `
  & .MuiButton-label {
    color: ${ui_components_1.baseColors.primaryBlueMed600};
  }
`;
